import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
import PaidAdReportDetails from 'components/PaidAd/Report/Details';
import { useQueryString } from 'helpers/effects';

const ScreenPaidAdReportRead = props => {
  const { classes, match } = props;
  const initialFilters = useQueryString();
  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs={12}>
          <GridItem>
            <PaidAdReportDetails
              id={match.params.id}
              initialFilters={initialFilters}
            />
          </GridItem>
        </GridItem>
      </GridContainer>
    </div>
  );
};

ScreenPaidAdReportRead.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenPaidAdReportRead);
